import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import {toastr} from "react-redux-toastr";
import debounce from 'lodash/debounce';
import PayoutPartnerComponent from "./component";
import { format } from 'date-fns';

const PayoutPartnerContainer = (props) => {
  const navigate = useNavigate();
  const [pendingPayouts, setPendingPayouts] = useState([]);
  const [scheduledPayouts, setScheduledPayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPayoutId, setSelectedPayoutId] = useState(null);
  const [showMarkSettleDialog, setShowMarkSettleDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [getDate, setGetDate] = useState();

  useEffect(() => {
    fetchPayoutData();
  }, []);

  const fetchPayoutData = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      '/partner/api/v3/acc/payouts/dashboard',
      'GET',
      undefined,
      (response) => {
        if (response) {
          setPendingPayouts(response.pending || []);
          setScheduledPayouts(response.scheduled || []);
          setGetDate(response.scheduled?.[0]?.date);
        } else {
          setPendingPayouts([]);
          setScheduledPayouts([]);
        }
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setError(err.message || "Failed to load payout data");
        toastr.error("Error", "Failed to load payout data");
        setLoading(false);
      }
    );
  }, 300);

  const handleMarkSettleClick = (payoutId) => {
    setSelectedPayoutId(payoutId);
    setShowMarkSettleDialog(true);
  };

  const handleMarkSettledConfirm = () => {
    // Format the date to YYYY-MM-DD (date only, no time)
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    
    props.getDataFromAPI(
      `/partner/api/v3/acc/payouts/mark-settle?date=${formattedDate}`,
      "PATCH",
      { settleDate: formattedDate },
      (response) => {
        setShowMarkSettleDialog(false);
        setShowSuccessDialog(true);
        fetchPayoutData();
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error("Error", err.message || "Failed to mark payout as settled");
      }
    );
  };

  const handleSuccessClose = () => {
    setShowSuccessDialog(false);
  };
  

  const handleProceed = (date) => {
    navigate(`/home/configuration/payoutpartners/scheduled/${date}`);
  };
  //   const handleScheduledProceed = (date) => {
  //   navnavigate(`/home/configuration/payoutpartners/mark-settle/schedule/download-report/${date}`);
  // };
  // /home/configuration/payoutpartners/mark-settle/schedule/download-report/:date

const handleMarkSettleData = (date)=>{
navigate(`/home/configuration/payoutpartners/marksettle/schedule/download-report/${date}`)
}


  const handleViewSettled = (date) => {
    navigate(`/home/configuration/payoutpartners/viewsettle`);
  };

  const handleViewPartners = () => {
    navigate(`/home/configuration/payoutpartners/partnerlist`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <PayoutPartnerComponent
      loading={loading}
      error={error}
      pendingPayouts={pendingPayouts}
      scheduledPayouts={scheduledPayouts}
      onProceed={handleProceed}
      onMarkSettle={handleMarkSettleClick}
      onViewSettled={handleViewSettled}
      onViewPartners={handleViewPartners}
      onGoBack={handleGoBack}
      showMarkSettleDialog={showMarkSettleDialog}
      setShowMarkSettleDialog={setShowMarkSettleDialog}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      onMarkSettledConfirm={handleMarkSettledConfirm}
      showSuccessDialog={showSuccessDialog}
      setShowSuccessDialog={setShowSuccessDialog}
      onSuccessClose={handleSuccessClose}
      handleMarkSettleData={handleMarkSettleData}
    />
  );
};

const mapStateToProps = (props) => ({
  props,
});

export default connect(mapStateToProps, {
  getDataFromAPI,
})(PayoutPartnerContainer);